// Goat gestation calculator used in Goat Pregnancy article. Referenced in sections/template-article.liquid
document.getElementById('calculate-due-date').addEventListener('click', function() {
    // Get the breeding date from the input
    var breedingDate = document.getElementById('breeding-date').value;

    if (breedingDate) {
        // Convert breeding date to a Date object
        var date = new Date(breedingDate);

        // Add 150 days to the date
        date.setDate(date.getDate() + 150);

        // Format the new date as YYYY-MM-DD
        var dueDate = date.toISOString().split('T')[0];

        // Display the due date result
        document.getElementById('due-date-result').innerText = "Your little one will arrive on: " + dueDate + " 🎉🐐 with a 150 day gestation period";
    } else {
        document.getElementById('due-date-result').innerText = "Please enter a breeding date. 🐐💖";
    }
});